import { render } from "./BasicInputError.vue?vue&type=template&id=52146cf8"
import script from "./BasicInputError.vue?vue&type=script&lang=js"
export * from "./BasicInputError.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__